// extracted by mini-css-extract-plugin
export default {"dailyScheduleWrapper":"daily-schedule-block-module--daily-schedule-wrapper--6e4ea"};